import React from 'react';
import { useTimer } from '../contexts/TimerContext.tsx';
import './MiniTimer.css';

interface MiniTimerProps {
  currentTaskName?: string | null;
}

const getSessionKind = (type: string): 'work' | 'break' | 'long' => {
  switch (type) {
    case 'pomodoro':   return 'work';
    case 'longBreak':  return 'long';
    case 'shortBreak':
    default:           return 'break';
  }
};

const getSessionDisplayName = (type: string) => {
  switch (type) {
    case 'pomodoro':   return 'Work';
    case 'shortBreak': return 'Short Break';
    case 'longBreak':  return 'Long Break';
    default:           return 'Work';
  }
};

const MiniTimer: React.FC<MiniTimerProps> = ({ currentTaskName }) => {
  const { timeLeft, initialTimeLeft, currentTab, isActive, sessionStarted, handleStartStop, handleSkip } = useTimer();

  const formatTime = (seconds: number) => {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins.toString().padStart(2, '0')}:${secs.toString().padStart(2, '0')}`;
  };

  const progress = initialTimeLeft > 0 ? ((initialTimeLeft - timeLeft) / initialTimeLeft) * 100 : 0;
  const kind = getSessionKind(currentTab);

  return (
    <div className="mini-timer" data-kind={kind}>
      <div className="mini-timer-header">
        <div className="mini-timer-session">
          {getSessionDisplayName(currentTab)}
        </div>
        <div className="mini-timer-controls">
          <button
            className={`mini-timer-status ${isActive ? 'active' : 'paused'}`}
            onClick={handleStartStop}
          >
            {isActive ? '⏸' : '▶'}
          </button>
          {sessionStarted && (
            <button className="mini-timer-skip" onClick={handleSkip} title="Skip session">
              ⏭
            </button>
          )}
        </div>
      </div>

      {currentTaskName && (
        <div className="mini-timer-task">
          <div className="mini-timer-task-label">Task:</div>
          <div className="mini-timer-task-name">{currentTaskName}</div>
        </div>
      )}

      <div className="mini-timer-time">
        {formatTime(timeLeft)}
      </div>

      <div className="mini-timer-progress-container">
        <div className="mini-timer-progress-bg"></div>
        <div
          className="mini-timer-progress-fill"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
    </div>
  );
};

export default MiniTimer;
